import {styled} from '@vw-marketing/us-components';

export const VideoWrapper = styled.div`
  width: 100%;
  height: auto;
`;
